(function(){
  function moneyFromCents(cents){
    try{
      const num = (cents || 0) / 100;
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(num);
    }catch(e){
      return '$' + (((cents || 0) / 100).toFixed(2));
    }
  }

  async function fetchCart(){
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if(!res.ok) throw new Error('cart fetch failed');
    return await res.json();
  }

  function renderMiniCart(root, cart){
    const body = root.querySelector('[data-mini-cart-body]');
    const countEl = root.querySelector('[data-mini-cart-count]');
    const subtotalEl = root.querySelector('[data-mini-cart-subtotal]');

    if(countEl) countEl.textContent = cart.item_count || 0;
    if(subtotalEl) subtotalEl.textContent = moneyFromCents(cart.total_price);

    if(!body) return;

    if(!cart.items || cart.items.length === 0){
      body.innerHTML = '<div class="mini-cart-empty">Your cart is empty.</div>';
      return;
    }

    const itemsHtml = cart.items.slice(0, 6).map(item => {
      const img = item.image ? `<img class="mini-cart-img" src="${item.image}" alt="${item.product_title || item.title}" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mini-cart-variant">${item.variant_title}</div>` : '';
      return `
        <div class="mini-cart-item">
          <a class="mini-cart-thumb" href="${item.url}">${img}</a>
          <div class="mini-cart-meta">
            <a class="mini-cart-title" href="${item.url}">${item.product_title || item.title}</a>
            ${variant}
            <div class="mini-cart-row">
              <span class="mini-cart-qty">Qty ${item.quantity}</span>
              <strong class="mini-cart-price">${moneyFromCents(item.final_line_price)}</strong>
            </div>
          </div>
        </div>
      `;
    }).join('');

    const more = cart.items.length > 6 ? `<div class="mini-cart-more">+ ${cart.items.length - 6} more item(s) in cart</div>` : '';
    body.innerHTML = itemsHtml + more;
  }

  function show(root){
    const panel = root.querySelector('.mini-cart');
    if(!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden','false');
  }

  function hide(root){
    const panel = root.querySelector('.mini-cart');
    if(!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden','true');
  }

  async function refresh(root){
    const body = root.querySelector('[data-mini-cart-body]');
    if(body) body.innerHTML = '<div class="mini-cart-loading">Loading…</div>';
    const cart = await fetchCart();
    renderMiniCart(root, cart);
  }

  function initOne(root){
    let hideTimer = null;
    let lastFetch = 0;

    const open = async () => {
      clearTimeout(hideTimer);
      show(root);
      const now = Date.now();
      if(now - lastFetch > 2000){
        lastFetch = now;
        try{ await refresh(root); }catch(e){ console.error(e); }
      }
    };

    const close = () => {
      clearTimeout(hideTimer);
      hideTimer = setTimeout(() => hide(root), 140);
    };

    root.addEventListener('mouseenter', open);
    root.addEventListener('mouseleave', close);
    root.addEventListener('focusin', open);
    root.addEventListener('focusout', close);

    document.addEventListener('woodies:cart-updated', (e) => {
      try{
        const cart = e.detail && e.detail.cart;
        if(cart) renderMiniCart(root, cart);
      }catch(err){ /* noop */ }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('[data-mini-cart]').forEach(initOne);
  });
})();
